/**
 * Compute the Tailwind className that enforces an admin's per-device visibility
 * choice for a homepage section.
 *
 * Reads three keys off the settings doc:
 *   <baseKey>            master toggle (legacy single-bool)
 *   <baseKey>_mobile     true → render on screens < md
 *   <baseKey>_desktop    true → render on screens ≥ md
 *
 * Returns:
 *   'block'              both
 *   'block md:hidden'    mobile only
 *   'hidden md:block'    desktop only
 *   'hidden'             always hidden
 */
export const visibilityClass = (settings, baseKey) => {
  if (!settings || settings[baseKey] === false) return 'hidden';
  const mobile = settings[`${baseKey}_mobile`] !== false;
  const desktop = settings[`${baseKey}_desktop`] !== false;
  if (mobile && desktop) return 'block';
  if (mobile && !desktop) return 'block md:hidden';
  if (!mobile && desktop) return 'hidden md:block';
  return 'hidden';
};
